import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SparePartsResultComponent } from '@ecs-features/result/spare-parts-result/spare-parts-result.component';
import { BaseTableModule } from '@os-components';

import { TypeDesignationResultComponent } from '../result/type-designation-result/type-designation-result.component';
import { SearchModule } from '../search/search.module';
import { LandingPageComponent } from './landing-page.component';

const routes: Routes = [
    {
        path: '',
        component: LandingPageComponent,
        children: [
            // Only use the "result" outlet with NAMED routes for actual result pages (no '' path) so it
            // can be reset to display nothing (e. g. in case of an error/no results).
            {
                path: 'spare-parts',
                outlet: 'result',
                component: SparePartsResultComponent,
            },
            {
                path: 'type-designation',
                outlet: 'result',
                component: TypeDesignationResultComponent,
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes), SearchModule, BaseTableModule],
})
export class LandingPageModule {}
